import React from "react";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import { orange } from "material-ui/colors";
import { withStyles } from "material-ui/styles";
import isMobile from "ismobilejs";
import classnames from "classnames";

import QuestionData from "assets/data/QuestionData";
import { isAnswer } from "utils/formatter";

import CInput from "uis/CInput";
import AttrEditDialog from "./AttrEditDialog";
import BasicEditDialog from "./BasicEditDialog";
import AdditionEditDialog from "./AdditionEditDialog";

const browserStyles = theme => ({
  container: {
    margin: 20,
    padding: 20,
    backgroundColor: theme.palette.answer.backgroundColor,
    minHeight: 570
  },
  main: {
    margin: "0 40px",
    padding: "20px 40px",
    backgroundColor: "white"
  },
  labelDiv: {
    margin: "20px 40px"
  },
  label: {
    fontSize: "1.6rem",
    borderBottom: `5px solid ${theme.palette.answer.borderColor}`,
    padding: "3px 20px"
  },
  attrWrapper: {
    marginBottom: 70
  },
  questionWrapper: {
    marginBottom: 70
  },
  otherWrapper: {
    marginBottom: 50
  },
  freeComment: {
    padding: "11px 13px 5px",
    flex: 1,
    color: theme.palette.primary.light
  },
  sectionLabel: {
    padding: "0 10px",
    fontSize: "1.2rem",
    borderBottom: `3px solid ${theme.palette.secondary.main}`
  },
  resultRow: {
    margin: 10,
    padding: "5px 0 10px",
    borderBottom: `1px solid ${theme.palette.answer.borderColor}`
  },
  result: {
    float: "left"
  },
  title: {
    padding: "0 15px 3px 7px",
    borderBottom: `2px solid ${theme.palette.answer.borderColor}`
  },
  attrItem: {
    padding: "0 10px",
    margin: 5,
    color: theme.palette.primary.light
  },
  basicItem: {
    margin: "5px 20px",
    color: theme.palette.primary.light
  },
  editBtnDiv: {
    float: "right",
    marginTop: 5
  },
  nextBtnDiv: {
    textAlign: "center",
    marginTop: 20
  },
  footer: {
    margin: 10
  },
  commentEditBtn: {
    margin: "5px 10px 0 0"
  },
  fcInput: {
    flex: 1,
    fontFamily: "sans-serif",
    color: "#555",
    margin: "0 20px"
  },
  fc1InputReadOnly: {
    border: "none",
    color: theme.palette.primary.light
  },
  fcOnEditColor: {
    backgroundColor: orange[700]
  },
  fcEditBtnRaised: {
    "&:hover": {
      backgroundColor: orange[700],
      boxShadow: "2px 3px 7px rgba(0,0,0,0.4);",
      opacity: 0.7
    }
  },
  clear: {
    clear: "both"
  }
});

const mobileStyles = theme => ({
  container: {
    margin: 10,
    padding: 10,
    backgroundColor: theme.palette.answer.backgroundColor
  },
  main: {
    backgroundColor: "white"
  },
  labelDiv: {
    marginBottom: 10
  },
  label: {
    fontSize: "1.0rem",
    borderBottom: `2px solid ${theme.palette.answer.borderColor}`,
    padding: "3px 10px"
  },
  attrWrapper: {
    marginBottom: 40
  },
  questionWrapper: {
    marginBottom: 40
  },
  otherWrapper: {
    marginBottom: 40,
    paddingBottom: 20
  },
  freeComment: {
    padding: "11px 13px 5px",
    flex: 1,
    color: theme.palette.primary.light
  },
  sectionLabel: {
    padding: "5px 10px",
    borderBottom: `2px solid ${theme.palette.secondary.main}`
  },
  resultRow: {
    padding: "0 10px 5px 0",
    borderBottom: `2px solid ${theme.palette.answer.borderColor}`
  },
  result: {},
  title: {
    padding: "5px 10px",
    borderBottom: `1px solid ${theme.palette.answer.borderColor}`
  },
  attrItem: {
    margin: "10px 0px 5px 15px",
    color: theme.palette.primary.light
  },
  basicItem: {
    margin: "10px 0px 5px 15px",
    color: theme.palette.primary.light
  },
  editBtnDiv: {
    float: "right",
    marginTop: -30
  },
  nextBtnDiv: {
    textAlign: "center",
    margin: 20
  },
  commentEditBtn: {
    margin: "5px 10px 0 0"
  },
  clear: {
    clear: "both"
  }
});

const FCEditButton = props => {
  const { classes, onEdit, handleIsFcEdit } = props;

  return (
    <Button
      raised
      dense
      onClick={() => handleIsFcEdit(!onEdit)}
      className={classnames(
        classes.commentEditBtn,
        onEdit ? classes.fcOnEditColor : null
      )}
      classes={{
        raised: onEdit ? classes.fcEditBtnRaised : null
      }}
    >
      {onEdit ? "完了" : "修正"}
    </Button>
  );
};

const FreeCommentComponent = props => {
  const {
    classes,
    label,
    inputValue,
    inputOnChange,
    isFcEdit,
    handleIsFcEdit
  } = props;

  return (
    <div id="FreeCommentComponent" className={classes.otherWrapper}>
      <div className={classes.sectionLabel}>{label}</div>

      <div style={{ display: "flex" }}>
        <CInput
          value={inputValue}
          multiline
          rows={3}
          rowsMax={10}
          onChange={inputOnChange}
          style={{
            width: '100%',
            margin: '-1px -3px 0 5px'
          }}
          innerRef={el => {
            this.fc1Input = el;
            return null;
          }}
          inputProps={{ readOnly: !isFcEdit }}
          className={classes.fcInput}
          classes={{
            input: isFcEdit ? null : classes.fc1InputReadOnly
          }}
        />

        <div className={classes.editBtnDivaaa}>
          <FCEditButton
            onEdit={isFcEdit}
            handleIsFcEdit={handleIsFcEdit}
            classes={classes}
          />
        </div>
      </div>
    </div>
  );
};

class AnswerResult extends React.Component {
  componentWillMount() {
    const { answerToken } = this.props.answerHeader;

    if (answerToken) {
      if (isAnswer()) {
        window.addEventListener("beforeunload", this.showReloadAlert);
      }
    } else {
      // answerTokenなしは認証エラー
      this.props.showErrorDialog();
    }
  }

  componentWillUnmount() {
    if (isAnswer()) {
      window.removeEventListener("beforeunload", this.showReloadAlert);
    }
  }

  showReloadAlert(e) {
    e.returnValue = "回答は削除されます。";
  }

  choiseSentence(num) {
    const { locale } = this.props.answerResult;
    return num ? QuestionData.CHOICES[locale.key].answers.find(
      answer => answer.id === num
    ).name : null;
  }

  titleFmt(no, title) {
    return `${no}. ${title}`;
  }

  render() {
    // 認証トークンがなければ画面の描写をしない
    if (!this.props.answerHeader.answerToken) {
      return null;
    }

    // state
    const { classes, answerResult, answerHeader, answerOther } = this.props;
    const {
      attrResult,
      basicResult,
      additionResult,
      freeComment1,
      freeComment2,
      isEditFreeComment1,
      isEditFreeComment2,
      attrEditDialog,
      basicEditDialog,
      additionEditDialog,
      locale
    } = answerResult;
    const { answerToken } = answerHeader;
    const { freeCommentDescriptions } = answerOther;

    // action
    const {
      handleCompleteBtn,
      handlePrevBtn,
      // attr edit dialog
      openAttrEditDialog,
      selectAttrItem,
      submitAttrDialog,
      closeAttrEditDialog,
      // basic edit dialog
      openBasicEditDialog,
      selectBasicItem,
      submitBasicDialog,
      closeBasicEditDialog,
      // addition edit dialog
      openAdditionEditDialog,
      selectAdditionItem,
      submitAdditionDialog,
      closeAdditionEditDialog,
      // 自由記入テキストの更新
      onChangeFreeCommentText1,
      onChangeFreeCommentText2,
      // 自由記入の編集フラグ
      onChangeIsEditFreeCommnet1,
      onChangeIsEditFreeCommnet2
    } = this.props;

    return (
      <div>
        <AttrEditDialog
          attrEditDialog={attrEditDialog}
          handleSelect={selectAttrItem}
          handleSubmit={submitAttrDialog}
          handleClose={closeAttrEditDialog}
        />

        <BasicEditDialog
          locale={locale}
          basicEditDialog={basicEditDialog}
          handleSelect={selectBasicItem}
          handleSubmit={submitBasicDialog}
          handleClose={closeBasicEditDialog}
        />

        <AdditionEditDialog
          additionEditDialog={additionEditDialog}
          handleSelect={selectAdditionItem}
          handleSubmit={submitAdditionDialog}
          handleClose={closeAdditionEditDialog}
        />

        <Paper className={classes.container}>
          <div className={classes.labelDiv}>
            <span className={classes.label}>回答結果一覧</span>
          </div>

          <Paper className={classes.main}>
            <div className={classes.attrWrapper}>
              <div className={classes.sectionLabel}>属性</div>

              <div className={classes.resultWrapper}>
                {Object.values(attrResult).map(r => (
                  <div key={r.surveyAttr.order} className={classes.resultRow}>
                    <div className={classes.result}>
                      <div>
                        <span className={classes.title}>
                          {this.titleFmt(
                            r.surveyAttr.order,
                            r.surveyAttr.attrName
                          )}
                        </span>
                      </div>

                      <div className={classes.attrItem}>
                        {r.attrItem.itemName}
                      </div>
                    </div>

                    <div className={classes.editBtnDiv}>
                      <Button
                        raised
                        dense
                        onClick={openAttrEditDialog(r.surveyAttr)}
                      >
                        修正
                      </Button>
                    </div>

                    <div className={classes.clear} />
                  </div>
                ))}
              </div>
            </div>

            <div className={classes.questionWrapper}>
              <div className={classes.sectionLabel}>質問</div>
              <div className={classes.resultWrapper}>
                {Object.values(basicResult).map(r => (
                  <div key={r.question.qNo} className={classes.resultRow}>
                    <div className={classes.result}>
                      <div className={classes.title}>
                        {this.titleFmt(r.question.qNo, r.question.text)}
                      </div>

                      <div className={classes.basicItem}>
                        {this.choiseSentence(r.num)}
                      </div>
                    </div>

                    <div className={classes.editBtnDiv}>
                      <Button
                        raised
                        dense
                        onClick={openBasicEditDialog(r.question)}
                      >
                        修正
                      </Button>
                    </div>

                    <div className={classes.clear} />
                  </div>
                ))}

                {Object.values(additionResult).map(r => (
                  <div key={r.addition.qNo} className={classes.resultRow}>
                    <div className={classes.result}>
                      <div className={classes.title}>
                        {this.titleFmt(r.addition.qNo, r.addition.text)}
                      </div>

                      <div className={classes.basicItem}>{r.choice.label}</div>
                    </div>

                    <div className={classes.editBtnDiv}>
                      <Button
                        raised
                        dense
                        onClick={openAdditionEditDialog(r.addition)}
                      >
                        修正
                      </Button>
                    </div>

                    <div className={classes.clear} />
                  </div>
                ))}
              </div>
            </div>

            <FreeCommentComponent
              classes={classes}
              label={freeCommentDescriptions[0]}
              inputValue={freeComment1}
              inputOnChange={e => onChangeFreeCommentText1(e.target.value)}
              isFcEdit={isEditFreeComment1}
              handleIsFcEdit={flg => onChangeIsEditFreeCommnet1(flg, freeComment1)}
            />

            {freeCommentDescriptions[1] && (
              <FreeCommentComponent
                classes={classes}
                label={freeCommentDescriptions[1]}
                inputValue={freeComment2}
                inputOnChange={e => onChangeFreeCommentText2(e.target.value)}
                isFcEdit={isEditFreeComment2}
                handleIsFcEdit={flg => onChangeIsEditFreeCommnet2(flg, freeComment2)}
              />
            )}
          </Paper>

          <div className={classes.nextBtnDiv}>
            <Button
              raised
              onClick={handleCompleteBtn(answerResult, answerToken)}
              disabled={isEditFreeComment1 || isEditFreeComment2}
            >
              確認完了
            </Button>
          </div>

          <div className={classes.footer}>
            {/* <Button raised dense onClick={handlePrevBtn}>
              前へ
            </Button> */}
          </div>
        </Paper>
      </div>
    );
  }
}

export default withStyles(isMobile.any ? mobileStyles : browserStyles)(
  AnswerResult
);



// WEBPACK FOOTER //
// ./src/components/answer/AnswerResult.jsx